var React = require('react');

function Forward (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 297.69L52.5 440.61C31.9 457.81 0 443.41 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 214.32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M500.5 231.41a32.11 32.11 0 0 1 0 49.2l-192 160c-20.6 17.2-52.5 2.8-52.5-24.6V96c0-27.4 31.9-41.7 52.5-24.6z","className":"fa-primary","key":2})]);
}

Forward.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Forward;

Forward.default = Forward;
